import { useTranslation } from 'react-i18next';

import { Form, Formik } from 'formik';

import { SingleSelect } from '@/common';
import { FilterModalLayout, FilterPopUpValues } from '@/components/layouts';
import { VideoThemeType } from '@/enums';
import { FilterThemesProps, SelectOptionProps } from '@/types';

export const FilterThemes = ({ onClose, filterByType, apply, reset }: FilterThemesProps) => {
  const [t] = useTranslation('common');

  const themeTypeOptions: SelectOptionProps[] = [
    { value: VideoThemeType.Public, label: t('public') },
    { value: VideoThemeType.Premium, label: t('premium') },
    { value: VideoThemeType.Organization, label: t('organization') }
  ];

  return (
    <Formik
      initialValues={{
        filterByType: filterByType ?? null
      }}
      onSubmit={() => undefined}>
      {({ setFieldValue, values }) => (
        <Form>
          <FilterModalLayout
            apply={apply as (values: FilterPopUpValues) => void}
            reset={reset}
            onClose={onClose}
            values={values}>
            <SingleSelect
              placeholder={t('selectType')}
              isClearable
              label={t('type')}
              id='filterByType'
              options={themeTypeOptions}
              handleChange={(value) => setFieldValue('filterByType', value as SelectOptionProps)}
              value={values.filterByType}
            />
          </FilterModalLayout>
        </Form>
      )}
    </Formik>
  );
};
